<template>
  <div class="not-found">
    <img
      class="imgs"
      src="https://cdn.51ljb.cn/ljb-404.png">
    <div
      class="btn"
      @click="goHome">点击唤醒</div>
  </div>
</template>

<script>
export default {
  name: 'ErrPage',
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
    goHome () {
      let url = location.origin
      url += '/h5/gzh/'
      window.location.href = url
    }
  }
}
</script>

<style lang="scss" scoped>
  .not-found{
    text-align: center;
    width: 100%;
    height: 100%;
    position: fixed;
    background: #fff;
    .imgs{
      width: 230px;
      height: 250px;
      margin-top: 50px;
    }
    .btn{
      width: 190px;
      font-size: 18px;
      color: #fff;
      background: #ffae5e;
      border-radius: 22px;
      display: inline-block;
      margin-top: 75px;
      line-height: 45px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ErrPage.vue